class PaginaDondeEstamos {
    constructor() {
        this.sections = document.getElementsByClassName("pagina-donde-estamos");
        if (this.sections[0]) {
            this.init();
        }
    }

    init() {
        console.log('Initializing Pagina Donde Estamos section');
        this.locations = document.querySelectorAll('.location[data-location-id]');
        const scrollTopButton = document.querySelector('#btnToTopDondeEstamos');
        // Store original locations for later use
        this.originalLocations = Array.from(this.locations);
        this.locationContainer = this.locations[0].parentElement;

        this.continentFilters = document.querySelectorAll('.continent-filter[data-location-id]');
        this.continentFilters.forEach((filter) => {
            filter.addEventListener('click', (event) => {
                this.handleFilterClick(event);
            });
        });

        if (scrollTopButton) {
            scrollTopButton.remove();
        }
        this.checkMultipleOfThree();
        
        this.locationContainer.appendChild(scrollTopButton);
    }

    handleFilterClick(event) {
        const filterId = event.currentTarget.getAttribute('data-location-id');

        if (filterId == 'all') {
            this.filtersToggleAll();
        } else {
            const allFilters = document.querySelectorAll('.continent-filter[data-location-id]');
            allFilters.forEach((filter) => {
                filter.classList.remove('active');
            });

            event.currentTarget.classList.toggle('active');
            this.filterLocations();
        }
    }

    filtersToggleAll() {
        const allFilters = document.querySelectorAll('.continent-filter[data-location-id]');
        const scrollTopButton = document.querySelector('#btnToTopDondeEstamos');
        allFilters.forEach((filter) => {
            filter.classList.remove('active');
        });

        // Remove all current locations
        while (this.locationContainer.firstChild) {
            this.locationContainer.removeChild(this.locationContainer.firstChild);
        }

        // Add all original locations back
        this.originalLocations.forEach(location => {
            this.locationContainer.appendChild(location.cloneNode(true));
        });

        // Check if the total number of locations is a multiple of 3
        this.checkMultipleOfThree()

        // Add scroll to top button
        this.locationContainer.appendChild(scrollTopButton);

        document.querySelector('.continent-filter[data-location-id="all"]').classList.add('active');
    }

    filterLocations() {
        const activeFilters = document.querySelectorAll('.continent-filter.active[data-location-id]');
        const scrollTopButton = document.querySelector('#btnToTopDondeEstamos');

        // Remove all current locations
        while (this.locationContainer.firstChild) {
            this.locationContainer.removeChild(this.locationContainer.firstChild);
        }

        if (activeFilters.length > 0) {
            // Add only filtered locations
            this.originalLocations.forEach(location => {
                activeFilters.forEach(filter => {
                    if (location.getAttribute('data-location-id') === filter.getAttribute('data-location-id')) {
                        this.locationContainer.appendChild(location.cloneNode(true));
                    }
                });
            });

            // Check if the total number of active locations is a multiple of 3
            this.checkMultipleOfThree()

            // Add scroll to top button
            this.locationContainer.appendChild(scrollTopButton);

        } else {
            this.filtersToggleAll();
        }
    }

    checkMultipleOfThree() {
        const allLocations = this.locationContainer.querySelectorAll('.location');
        if (allLocations.length % 3 !== 0) {
            // Add empty divs to fill the last row
            const emptyDivCount = 3 - (allLocations.length % 3);
            for (let i = 0; i < emptyDivCount; i++) {
                const emptyDiv = document.createElement('div');
                emptyDiv.classList.add('location', 'empty');
                this.locationContainer.appendChild(emptyDiv);
            }
        }
    }
}

export default PaginaDondeEstamos;


/*
class PaginaDondeEstamos {
    constructor() {
        this.sections = document.getElementsByClassName("pagina-donde-estamos");
        if (this.sections[0]) {
            this.init();
        }
    }

    init() {
        console.log('Initializing Pagina Donde Estamos section');
        this.locations = document.querySelectorAll('.location[data-location-id]');

        this.continentFilters = document.querySelectorAll('.continent-filter[data-location-id]');
        this.continentFilters.forEach((filter) => {
            filter.addEventListener('click', (event) => {
                this.handleFilterClick(event);
            });
        });
    }

    handleFilterClick(event) {
        const filterId = event.currentTarget.getAttribute('data-location-id');

        if (filterId == 'all') {
            this.filtersToggleAll();
        } else {
            document.querySelector('.continent-filter[data-location-id="all"]').classList.remove('active');
            event.currentTarget.classList.toggle('active');
            this.filterLocations();
        }
    }

    filtersToggleAll() {
        const allLocations = document.querySelectorAll('.location');
        const allFilters = document.querySelectorAll('.continent-filter[data-location-id]');
        allFilters.forEach((filter) => {
            filter.classList.remove('active');
        });
        allLocations.forEach((location) => {
            location.classList.remove('hidden');
        });
        document.querySelector('.continent-filter[data-location-id="all"]').classList.add('active');
    }

    filterLocations() {
        const activeFilters = document.querySelectorAll('.continent-filter.active[data-location-id]');
        const allLocations = document.querySelectorAll('.location');

        allLocations.forEach((location) => {
            location.classList.add('hidden');
        });

        if (activeFilters.length > 0) {
            activeFilters.forEach((filter) => {
                allLocations.forEach((location) => {
                    if (location.getAttribute('data-location-id') == filter.getAttribute('data-location-id')) {
                        location.classList.remove('hidden');
                    }
                });
            });
        } else {
            this.filtersToggleAll();
        }
    }

}

export default PaginaDondeEstamos;
*/
